import { FC, useContext, useEffect, useState } from "react";
import {
  FormControl,
  Grid,
  InputLabel,
  Paper,
  Select,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Backdrop,
  CircularProgress,
  Container,
} from "@mui/material";
import Cookies from "universal-cookie";
import { AllMounth } from "../../../constants/Constants";
import axios, { AxiosInstance } from "axios";

import CheckAttr from "../../../utils/CheckAttr";
import { StyledTableCell } from "../../content/parametrage/Pays/Pays";
import { urlApi } from "../../content/parametrage/Pays/RowPays";
import { DataUtilisateur } from "../../content/parametrage/user/Tabs/utilisateur/Utilisateur";
import RowCommission from "./RowCommission";
import { useSelector } from "react-redux";
import { Reducers } from "../../../redux/reducers";
import UserInformation from "../../../types/UserInformation";

interface FilterParams {
  month?: string;
  year?: string;
}

const initialFilter: FilterParams = {
  month: "",
  year: "",
};

interface CommissionFormProps {
  utilisateur?: DataUtilisateur;
  // handleRefreshUsersDatas: (user: UserInformation, action: ActionType) => void;
}

export interface ArticleParMoisAvecCommissionI {
  userId: number;
  name?: string;
  articlesId: number;
  articles: string;
  devises_id: number;
  code_iso: string;
  operationId?: number;
  operation: string;
  client_id?: number;
  client: string;
  Mois: number;
  Annee: number;
  SUM_Heure?: number;
  SUM_Acte?: any;
  tarifId?: number;
  tarifacte?: any;
  tarifheure?: number;
  ca?: number;
  commissionCommercialsId: number;
  taux_commission: number;
  Commission: number;
  Commission_Devise?: number;
  typeId?: number
  type?:string
}

const CommissionForm: FC<CommissionFormProps> = ({ utilisateur }) => {
  
  const logger = useSelector<Reducers>(
    (state) => state.logger
  ) as UserInformation;


  const yearsToDisplay = [new Date().getFullYear()];
  console.log(new Date().getMonth());
  const AllMounthCorriger = AllMounth?.filter((mounth) => mounth?.id <= new Date().getMonth() +1 );

  const [filterParams, setFilterParams] = useState<FilterParams>(initialFilter);
  const [allArticleParMoisAvecCommission, setAllArticleParMoisAvecCommission] =
    useState<ArticleParMoisAvecCommissionI[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const cookies = new Cookies();
  const token: string = cookies.get("jwt");
  const http: AxiosInstance = axios.create({
    baseURL: urlApi,
    // timeout: 1000,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const getArticleWithCommission = () => {
    const data = {
      userId: utilisateur ? utilisateur?.id : logger?.id,
      annee: filterParams?.year,
      mois: filterParams?.month,
    };
    setIsLoading(true);
    http
      .post("article/commission/by/user", data)
      .then((res) => {
        setAllArticleParMoisAvecCommission(res.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  console.log(allArticleParMoisAvecCommission);
  useEffect(() => {
    getArticleWithCommission();
  }, [filterParams]);

  const handleChangeFilter = (e: any) => {
    const { name, value } = e.target;

    setFilterParams({
      ...filterParams,
      [name]: value,
    });
  };
  return (
    <>
      <Container maxWidth="xl">
        <Grid container spacing={0.5} columns={{ xs: 6, sm: 10, md: 12 }}>
          <Grid item xs={0} sm={4} md={8} spacing={1.5}></Grid>
          <Grid item xs={4} sm={4} md={2}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel
                htmlFor="Mois"
                color="warning"
                shrink={CheckAttr(filterParams?.month)}
                sx={{ mt: -1 }}
              >
                Mois
              </InputLabel>
              <Select
                id="Mois"
                native
                color="warning"
                sx={{ background: "#fff" }}
                size="small"
                value={filterParams?.month}
                name="month"
                onChange={handleChangeFilter}
                label="Mois"
              >
                <option value={0}></option>
                {AllMounthCorriger.map((m) => (
                  <option value={m.id}>{m.mounth}</option>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={4} sm={4} md={2}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel
                htmlFor="year"
                color="warning"
                shrink={CheckAttr(filterParams?.year)}
                sx={{ mt: -1 }}
              >
                Année
              </InputLabel>
              <Select
                id="year"
                native
                color="warning"
                sx={{ background: "#fff" }}
                size="small"
                name="year"
                value={filterParams?.year}
                onChange={handleChangeFilter}
                label="year"
                inputProps={{
                  name: "year",
                }}
              >
                <option value={0}></option>
                {yearsToDisplay.map((y) => (
                  <option value={y}>{y}</option>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <br></br>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell align="center">client</StyledTableCell>
                <StyledTableCell align="center">opération</StyledTableCell>
                <StyledTableCell align="center">
                  désignation article
                </StyledTableCell>
                <StyledTableCell align="center">mois - année</StyledTableCell>
                <StyledTableCell align="center">
                  type
                </StyledTableCell>
                <StyledTableCell align="center">CA</StyledTableCell>
                <StyledTableCell align="center">taux De Commission</StyledTableCell>
                <StyledTableCell align="center">commission</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {allArticleParMoisAvecCommission?.map((article) => (
                <RowCommission article={article} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
      <div>
        <Backdrop
          sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </>
  );
};

export default CommissionForm;
